export default "__VITE_ASSET__BqjQPgoQ__"